<div class="fleet-pricing-dialog">
  <div class="fleet-pricing-dialog-header flex-between-center">
    <p class="m-0 font-bold">
      <i class="fal fa-cars font-gray-55 font-18 pr-2"></i>
      <span>Fleet override</span>
    </p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="closeDialog()"></i>
    </span>
  </div>

  <div class="fleet-pricing-dialog-body ui-g">
    <custom-fleet-setting class="ui-g-12" [errors]="errors" [user]="user" [fleetSettings]="fleetSettings"
      (handleDataChange)="updateFleetSettings($event)">
    </custom-fleet-setting>
  </div>

  <div class="fleet-pricing-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="closeDialog()">Cancel</button>

    <button class="btn btn-primary btn-submit" [disabled]="isLoading || isSubmitting" (click)="handleSubmit()">
      <span [ngClass]="{'pr-2': isSubmitting}">Save</span>
      <i class="fal fa-spinner rotate" *ngIf="isSubmitting"></i>
    </button>
  </div>
</div>
